import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Column } from '@appcues/component-library';

import { API_KEYS } from 'next/entities/features';
import useTitle from 'next/hooks/use-title';
import { selectAccountFeature } from 'reducers/account/features';

import ProfilePanel from './ProfilePanel';
import AccountAPIKeysPanel from './AccountAPIKeysPanel';
import AccountSettingsPanel from './AccountSettingsPanel';
import FrequencyCappingPanel from './FrequencyCappingPanel';
import CustomerSupportPanel from './CustomerSupportPanel';

const AccountPage = ({ hasAPIKeys = false }) => {
  useTitle('Account | Settings | Appcues');
  return (
    <Row setChildrenEqualSize marginTop={0}>
      <Column>
        <ProfilePanel />
        {!hasAPIKeys && <AccountAPIKeysPanel />}
        <CustomerSupportPanel />
      </Column>
      <Column>
        <AccountSettingsPanel />
        <FrequencyCappingPanel />
      </Column>
    </Row>
  );
};

AccountPage.propTypes = {
  hasAPIKeys: PropTypes.bool,
};

const mapStateToProps = state => ({
  hasAPIKeys: selectAccountFeature(state, API_KEYS),
});

export default connect(mapStateToProps)(AccountPage);
